import { StyledLoginTermsBlock } from '../style';

interface ILoginTermsBlockProps {
  textColor?: string;
  textSize?: string;
  openInfoModal: any;
  privacyPolicyLink?: string;
  termsAndConditionsLink?: string;
  openInNewTab?: boolean;
  translations: any;
}
// ACDEV-8185: moved to store
export const LoginTermsBlock: React.FC<ILoginTermsBlockProps> = ({
  textColor = 'black',
  textSize = '16px',
  openInfoModal,
  privacyPolicyLink,
  termsAndConditionsLink,
  openInNewTab = false,
  translations,
}) => {
  return (
    <StyledLoginTermsBlock
      textColor={textColor}
      textSize={textSize}
      className={'login-terms-text'}
    >
      <span className="terms-wrapper">
        {translations.byLoggingIn}{' '}
        <span
          onClick={() => {
            openInNewTab
              ? window.open(privacyPolicyLink, '_blank')
              : openInfoModal(privacyPolicyLink);
          }}
        >
          {translations.privacyPolicy}
        </span>{' '}
        {translations.and}{' '}
        <span
          onClick={() => {
            openInNewTab
              ? window.open(termsAndConditionsLink, '_blank')
              : openInfoModal(termsAndConditionsLink);
          }}
        >
          {translations.termsAndConditions}
        </span>
      </span>
    </StyledLoginTermsBlock>
  );
};
